import { DialogProps } from 'primevue/dialog'
import type { DialogDesignTokens } from '@primeuix/themes/types/dialog'
import Modal from './Modal.vue'
import { LocalStorageKey } from '@/services/LocalStorageService'

export interface ModalProps extends DialogProps {
  hideContent?: boolean
  modalWidth?: string
  localStorageKey?: LocalStorageKey
}

export interface ModalEmits {
  (e: 'update:visible', value: boolean): void
  (e: 'hide'): void
  (e: 'after-hide'): void
  (e: 'show'): void
}

export const ModalStyleConfig: DialogDesignTokens = {
  root: {
    color: 'var(--color-text)',
    borderRadius: 'var(--modal-radius)',
    shadow: '0px 4px 24px 0px rgba(12, 28, 25, 0.16)'
  },
  header: {
    padding: 'var(--padding-lg)'
  },
  footer: {
    padding: 'var(--padding-lg)'
  },
  content: {
    padding: 'var(--padding-lg)'
  },
  title: {
    fontSize: '16px',
    fontWeight: '700'
  }
}

export enum ModalStates {
  VIEWED = 1
}

export default Modal
